<template>
  <v-dialog
    v-model="opened"
    content-class="add-expense-dialog"
    max-width="350"
    persistent
  >
    <h3 class="add-expense-dialog__title">
      {{ title }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="expense-form" @submit.prevent="onSubmit">
      <v-text-field
        v-model="name"
        outlined
        dense
        :label="$t('companiesList.tableHeaders.name')"
        :rules="[isRequired]"
      />
      <v-btn
        type="submit"
        elevation="0"
        color="warning"
        block
        :loading="loading"
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>

    <v-snackbar v-model="snack.opened" :color="snack.color" top>
      {{ snack.message }}
    </v-snackbar>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    typeId: Number,
    categoryId: Number,
    currentName: [String, null],
  },
  data: () => ({
    loading: false,
    name: '',

    snack: {
      opened: false,
      color: null,
      message: null,
    },
  }),
  watch: {
    opened(value) {
      if (!value) this.$refs['expense-form'].reset();
      if (value && this.currentName) {
        this.name = this.currentName;
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    title() {
      if (!this.typeId) {
        return this.$t('finance.expenceTypeAdd');
      }

      if (this.currentName) {
        return `${this.$t('common.btns.edit')} ${this.currentName}`;
      }

      const list = this.$store.state['company-expenses'].configuratorList;
      const type = list.find(({ id }) => id === this.typeId);

      return `${this.$t('finance.categoryAdd')} ${type.name}`;
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    processResult(success, message) {
      if (success) {
        this.$emit('updated');
        this.opened = false;
      } else {
        this.snack.opened = true;
        this.snack.message = message;
        this.snack.color = 'error';
      }
    },
    async addNewType() {
      this.loading = true;
      const params = {
        type: 'types',
        title: this.name,
      };

      const { success, message } = await this.$store.dispatch(
        'company-expenses/updateProperty',
        {
          params,
          type: 'add',
        },
      );

      this.processResult(success, message);
      this.loading = false;
    },
    async addNewCategory() {
      this.loading = true;
      const params = {
        type: 'categories',
        title: this.name,
        typeId: this.typeId,
      };

      const { success, message } = await this.$store.dispatch(
        'company-expenses/updateProperty',
        {
          params,
          type: 'add',
        },
      );

      this.processResult(success, message);
      this.loading = false;
    },
    async updateType() {
      this.loading = true;
      const params = {
        type: 'types',
        name: this.name,
        id: this.typeId,
      };

      const { success, message } = await this.$store.dispatch(
        'company-expenses/updateProperty',
        {
          params,
          type: 'update',
        },
      );

      this.processResult(success, message);
      this.loading = false;
    },
    async updateCategory() {
      this.loading = true;
      const params = {
        type: 'categories',
        name: this.name,
        id: this.categoryId,
      };

      const { success, message } = await this.$store.dispatch(
        'company-expenses/updateProperty',
        {
          params,
          type: 'update',
        },
      );

      this.processResult(success, message);
      this.loading = false;
    },
    onSubmit() {
      const isValid = this.$refs['expense-form'].validate();

      if (!isValid) return;

      if (!this.typeId) this.addNewType();
      else if (this.categoryId) this.updateCategory();
      else if (this.typeId && !this.currentName) this.addNewCategory();
      else if (this.typeId && this.currentName) this.updateType();
    },
  },
};
</script>

<style lang="scss">
.add-expense-dialog {
  padding: 10px;
  background-color: #fff;

  &__title {
    margin-bottom: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 30px;
  }
}
</style>
